/* =========================================================
   DOÑA TOMASA · CARGADOR DE PERSONALIZACIONES
   Conserva el JS anterior y activa el banner corporativo V2
   ========================================================= */

(() => {
  'use strict';

  const ORIGINAL_FILE = 'bss-custom-before-regalos-corporativos-20261012.js';
  const CORPORATE_CSS_FILE = 'dt-regalos-corporativos.css';
  const PAGE_SCOPE = 'body.template-page-regalos-corporativos, body#regalos-corporativos';

  const sourceElement =
    document.currentScript ||
    Array.from(document.scripts).find((script) => /\/assets\/bss-custom\.js(?:[?#]|$)/.test(script.src || '')) ||
    document.querySelector('link[href*="/assets/bss-custom.css"]');

  function assetUrl(filename) {
    const source = sourceElement && (sourceElement.src || sourceElement.href);
    if (!source) return '';

    try {
      const url = new URL(source, window.location.href);
      url.pathname = url.pathname.replace(/\/assets\/[^/]+$/, `/assets/${filename}`);
      url.search = '';
      url.hash = '';
      return url.toString();
    } catch (error) {
      return '';
    }
  }

  function loadPreviousCustomJs() {
    if (window.__dtPreviousBssCustomJsRequested) return;
    window.__dtPreviousBssCustomJsRequested = true;

    const src = assetUrl(ORIGINAL_FILE);
    if (!src) {
      console.error('[Doña Tomasa] No se ha podido localizar el JS personalizado anterior.');
      return;
    }

    const script = document.createElement('script');
    script.src = src;
    script.async = false;
    script.dataset.dtPreviousBssCustom = 'true';
    script.onerror = () => {
      console.error('[Doña Tomasa] No se ha podido cargar el JS personalizado anterior.');
    };

    (document.head || document.documentElement).appendChild(script);
  }

  function onCorporatePage() {
    return document.body && document.body.matches(PAGE_SCOPE);
  }

  function installCriticalCorporateStyles() {
    if (document.getElementById('dt-corporate-critical-v2')) return;

    const style = document.createElement('style');
    style.id = 'dt-corporate-critical-v2';
    style.textContent = `
      :is(body.template-page-regalos-corporativos, body#regalos-corporativos) .breadcrumb-main,
      :is(body.template-page-regalos-corporativos, body#regalos-corporativos) .dt-corp-hero__image {
        display: none !important;
      }

      :is(body.template-page-regalos-corporativos, body#regalos-corporativos) #main {
        padding-top: 0 !important;
        margin-top: -80px !important;
      }

      @media screen and (max-width: 767px) {
        :is(body.template-page-regalos-corporativos, body#regalos-corporativos) #main {
          margin-top: -48px !important;
        }
      }

      :is(body.template-page-regalos-corporativos, body#regalos-corporativos) .dt-corp-hero {
        background: #fbf8f2 !important;
      }
    `;
    document.head.appendChild(style);
  }

  function loadCorporateStylesheet() {
    if (document.getElementById('dt-regalos-corporativos-css')) return;

    const href = assetUrl(CORPORATE_CSS_FILE);
    if (!href) return;

    const link = document.createElement('link');
    link.id = 'dt-regalos-corporativos-css';
    link.rel = 'stylesheet';
    link.href = href;
    document.head.appendChild(link);
  }

  function updateCorporateHero() {
    if (!onCorporatePage()) return false;

    document.body.classList.add('dt-corporate-banner-v2');
    installCriticalCorporateStyles();
    loadCorporateStylesheet();

    const hero = document.querySelector('.dt-corp-hero');
    if (!hero) return false;

    let eyebrow = hero.querySelector('.dt-corp-hero__eyebrow');
    if (!eyebrow) {
      eyebrow = document.createElement('p');
      eyebrow.className = 'dt-corp-hero__eyebrow';
      const title = hero.querySelector('.dt-corp-hero__title');
      if (title) title.parentNode.insertBefore(eyebrow, title);
    }
    eyebrow.textContent = 'SOLUCIONES PARA EMPRESAS';

    const heading = hero.querySelector('.dt-corp-hero__title');
    if (heading) {
      heading.textContent = 'Regalos Gourmet Corporativos';
    }

    const subtitle = hero.querySelector('.dt-corp-hero__subtitle');
    if (subtitle) {
      subtitle.textContent = 'Envía tus regalos a múltiples destinatarios de forma rápida, fácil y segura.';
    }

    const budgetButton =
      hero.querySelector('.dt-corp-btn--secondary') ||
      Array.from(hero.querySelectorAll('a')).find((link) =>
        /solicitar\s+presupuesto/i.test(link.textContent || '')
      );

    if (budgetButton) {
      budgetButton.href = 'https://donatomasa.com/pages/registro-de-empresas';
    }

    hero.querySelector('.dt-corp-hero__image')?.remove();
    hero.classList.add('dt-corp-hero--compact');

    return true;
  }

  function initCorporateHero() {
    if (!onCorporatePage()) return;

    if (updateCorporateHero()) return;

    const observer = new MutationObserver(() => {
      if (updateCorporateHero()) observer.disconnect();
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true
    });

    window.setTimeout(() => observer.disconnect(), 10000);
  }

  loadPreviousCustomJs();

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCorporateHero, { once: true });
  } else {
    initCorporateHero();
  }
})();

